var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "255.50151mm",
    height: "132.29167mm",
    viewBox: "0 0 255.50151 132.29167",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826125e-7,-164.70834)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D7\\uE1D5    \\uE1D7",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26515198px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "text108",
    transform: "matrix(1.3530135,0,0,1.3530135,-3.2062849e-7,-79.623348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 43.415721,207.64299 c -4.930871,-7.5767 -9.019887,-15.5142 -10.463068,-24.77462 -0.360796,-1.56345 -1.082387,-2.04451 -2.886364,-2.04451 -0.481061,0 -0.962121,0.12027 -0.962121,0.84186 v 0.12026 c 0,0 0,0.24053 0,0.48106 v 22.60985 c 0,0 0,0 0,0 v 48.58712 c -1.924243,-1.68371 -4.570076,-2.52556 -7.69697,-2.52556 -11.9062501,0 -21.40719709173874,8.77935 -21.40719709173874,18.03977 0,5.65246 4.57007579173874,9.01989 10.46306809173874,9.01989 9.621212,0 21.527462,-8.89963 21.527462,-18.03978 v -53.99905 c 5.892993,3.72822 12.988637,14.31155 15.995266,21.28693 1.443181,3.24716 2.285037,8.77936 2.285037,14.43182 0,4.32955 -0.601325,8.89962 -2.285037,13.22917 -0.120266,0.48106 -0.240531,0.96212 -0.240531,1.44318 0,1.44318 0.962121,2.4053 1.563447,2.7661 l 0.120265,0.12026 c 0.841856,0 2.044508,-0.36079 2.525569,-1.92424 0,0 2.525568,-9.14015 2.525568,-16.71686 0,-12.02651 -5.051137,-23.33144 -11.064394,-32.95265 z",
    style: {
      strokeWidth: 0.62638098
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.599315,253.70455 c -1.924242,-1.68372 -4.570075,-2.52557 -7.696969,-2.52557 -11.90625,0 -21.407197,8.77935 -21.407197,18.16003 0,5.65247 4.570075,9.01989 10.463068,9.01989 9.621212,0 21.527462,-9.01989 21.527462,-18.16004 v -79.61553 h -2.886364 z",
    style: {
      strokeWidth: 0.62638098
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 177.77445,207.64299 c -4.93087,-7.5767 -9.01988,-15.5142 -10.46306,-24.77462 -0.3608,-1.56345 -1.08239,-2.04451 -2.88637,-2.04451 -0.48106,0 -0.96212,0.12027 -0.96212,0.84186 v 0.12026 c 0,0 0,0.24053 0,0.48106 v 22.60985 c 0,0 0,0 0,0 v 48.58712 c -1.92424,-1.68371 -4.57007,-2.52556 -7.69697,-2.52556 -11.90625,0 -21.40719,8.77935 -21.40719,18.03977 0,5.65246 4.57007,9.01989 10.46306,9.01989 9.62122,0 21.52747,-8.89963 21.52747,-18.03978 v -53.99905 c 5.89299,3.72822 12.98863,14.31155 15.99526,21.28693 1.44318,3.24716 2.28504,8.77936 2.28504,14.43182 0,4.32955 -0.60133,8.89962 -2.28504,13.22917 -0.12026,0.48106 -0.24053,0.96212 -0.24053,1.44318 0,1.44318 0.96212,2.4053 1.56345,2.7661 l 0.12026,0.12026 c 0.84186,0 2.04451,-0.36079 2.52557,-1.92424 0,0 2.52557,-9.14015 2.52557,-16.71686 0,-12.02651 -5.05114,-23.33144 -11.0644,-32.95265 z",
    style: {
      strokeWidth: 0.62638098
    },
    id: "path128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqe);
export default __webpack_public_path__ + "static/media/eqe.95d5c08e2d08ba07756bf14cdc79d880.svg";
export { ForwardRef as ReactComponent };